import { graphql } from 'gatsby'
import React from 'react'
import Layout from '../shared/components/organisms/layout/layout'
import useLocaleMode from '../shared/hooks/useLocaleMode'
import useMobileMode from '../shared/hooks/useMobileMode'
import SEO from './../shared/components/seo'
import './../shared/_shared/Index.scss'

const IndexPage = (props) => {

  const { locale } = useLocaleMode();
  const { isMobile } = useMobileMode();

  return (
    <Layout title={"titulo"} isMobile={isMobile} showHeader={false}>
      <SEO
        title={"titulo"}
        description={"description"}
        lang={locale}
      />
    </Layout>
  )
};

export default IndexPage;